<template>
    <section class="subscription-ssn-management" v-if="this.$root.whitelabel.isUs() && ssnRequested && hasSsn && !inquiryAccepted">
        <div class="row">
            <data-entry-column :title="$t('co.personal_data.ssn')" :full-width="true">
                <template v-slot:value>
                    <small class="text-muted">{{ $t('co.personal_data.ssn.info.text') }}</small>
                </template>
            </data-entry-column>
        </div>
    </section>
</template>

<script>
import DataEntryColumn from "../atoms/DataEntryColumn.vue";

export default {
    name: 'SubscriptionSsnManagement',

    components: {
        DataEntryColumn
    },

    props: {
        subscriptionData: null
    },

    data() {
        return {
        }
    },

    methods: {
    },

    computed: {
        getName() {
            return this.subscriptionData.user_name ?? ''
        },
        ssnRequested() {
            if(this.subscriptionData.ssn_requested == true) {
                return true
            } 
            return false
        },
        hasSsn() {
            if(this.subscriptionData.user_has_ssn == true) {
                return true
            } 
            return false
        },
        inquiryAccepted() {
            if(this.subscriptionData.status === 'SUBSCRIPTION_INQUIRY_ACCEPTED') {
                return true
            } 
            return false
        }
    },

    mounted() {
    }
}
</script>
